import { get } from 'lodash/fp';
import axios from './axios';

export default (jobUid, designName) =>
  axios.post(`/jobs/${jobUid}/designs`, {
    designName,
  })
    .then(get('data'));
